import React from 'react'

const ArrowRightIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='30' height='54' viewBox='0 0 30 54'><g><g><path fill='#677377' d='M.15 50.394L4 54l26.07-27.228L4.875.787.937 4.724l21.26 22.048L.15 50.394' /></g></g></svg>
)

export default ArrowRightIcon
